import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-6 col-12" }
const _hoisted_6 = { class: "mb-0" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Channels Queue management ")
const _hoisted_8 = { class: "row w-100" }
const _hoisted_9 = { class: "col-12 col-md-6 col-lg-9 my-1" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted h6 font-weight-normal mt-2" }, " Insert phone number without symbols (+, -, etc) or spaces ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted h6 font-weight-normal mt-2" }, " Insert your Description ", -1)
const _hoisted_12 = { class: "col-12 col-md-6 col-lg-3 my-1" }
const _hoisted_13 = { class: "d-flex flex-row" }
const _hoisted_14 = { class: "d-flex align-items-center my-1" }
const _hoisted_15 = {
  key: 1,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Save ")
const _hoisted_17 = { class: "d-flex align-items-center" }
const _hoisted_18 = {
  key: 1,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Delete ")
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h4", null, "Add queue channel config", -1)
const _hoisted_21 = { class: "row w-100" }
const _hoisted_22 = { class: "col-12 my-1" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted h6 font-weight-normal mt-2" }, " Key of request clasification ", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted h6 font-weight-normal mt-2" }, " Request clasification label shows in the webpage ", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted h6 font-weight-normal mt-2" }, " Insert phone number without symbols (+, -, etc) or spaces ", -1)
const _hoisted_26 = { class: "col-12 my-1" }
const _hoisted_27 = { class: "d-flex flex-row" }
const _hoisted_28 = { class: "d-flex align-items-center my-1" }
const _hoisted_29 = {
  key: 1,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Save ")

import { computed, ref, onMounted } from "vue";
import { AlertModule } from "@/store/modules/Alert";
import { iInvalidSubmit } from "@/composables/vee-validate";
import { IndexType } from "@/types/store";
import { Field } from "@/types/components";
import { Form, FormActions } from "vee-validate";
import { CircleCloseFilled, List, WarningFilled, RefreshRight, Plus } from "@element-plus/icons";
import BaseInput from "@/components/Inputs/BaseInput.vue";
import { QueueManagementAPI } from "@/conection/index";
import Modal from "@/components/Modal.vue";

import type { Ref } from 'vue'

import * as yup from "yup";

export interface ICallChannel {
  rclassification: string;
  rclassificationName: string;
  number: string;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const form = ref<IndexType<Field>>({});
const items: Ref<ICallChannel[]> = ref([])
const formkey = ref(0);
const formComponent = ref<
	| (FormActions<any> & {
			getValues: () => { [k: string]: string | undefined };
	  })
	| null
>(null);

onMounted(async () => {
await getData();
});
const loading = ref(false);
const openModal = ref(false);

//computed
const schema = yup.object({
	rclassification: yup.string().required(),
	number: yup.string().required(),
	rclassificationName: yup.string().required(),

});
async function getData() {
	loading.value = true;
	try {
		const response = await QueueManagementAPI.get("call");
		if (response.status === 200) {
			console.log(" response.data", response.data);
			
			items.value = response.data;
		}
	} catch (error) {
		loading.value = false;
	}

	loading.value = false;
}
async function onSubmit(values: any) {
	loading.value = true;
	try {
		console.log(values);
		const response = await QueueManagementAPI.post("call/upsert", values);
		if (response.status === 201) {
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: `Configuration saved successfully`,
				type: "success",
			});
		} else {
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: `Error// Configuration has not been saved`,
				type: "error",
			});
		}
	} catch (error) {
		loading.value = false;

		AlertModule.SOCKET_PUSH_NOTIFICATION({
			text: `Error// Configuration has not been saved`,
			type: "error",
		});
	}

	loading.value = false;
}
 async function deleteClassification(rclassification: string){
	console.log(rclassification)
	loading.value = true;
	try {
		const response = await QueueManagementAPI.delete("call/delete/"+rclassification);
		if (response.status === 200) {
			await getData();
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: response.data,
				type: "success",
			});
		} else {
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: `Error// Can not removed`,
				type: "error",
			});
		}
	} catch (error) {
		loading.value = false;

		AlertModule.SOCKET_PUSH_NOTIFICATION({
			text: `Error// Can not removed`,
			type: "error",
		});
	}

	loading.value = false;
}

function onInvalidSubmit(values: iInvalidSubmit) {
	const errMsgs: string[] = Object.keys(values.errors);

	AlertModule.SOCKET_PUSH_NOTIFICATION({
		text: `Please Check ${errMsgs.join()}`,
		type: "error",
	});
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_card, { "header-classes": "bg-transparent" }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("h3", _hoisted_6, [
                    _hoisted_7,
                    _createVNode(_component_el_tooltip, {
                      class: "box-item",
                      content: "Refresh",
                      placement: "bottom"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          class: "ml-1",
                          onClickCapture: _cache[0] || (_cache[0] = ($event: any) => ( getData())),
                          icon: _unref(RefreshRight),
                          circle: ""
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_tooltip, {
                      class: "box-item",
                      content: "Add config",
                      placement: "bottom"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          class: "ml-2",
                          onClickCapture: _cache[1] || (_cache[1] = ($event: any) => ( openModal.value = true)),
                          type: "info",
                          icon: _unref(Plus),
                          circle: ""
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.rclassification
                }, [
                  (_openBlock(), _createBlock(_unref(Form), {
                    class: "w-100 form-inline",
                    ref_for: true,
                    ref_key: "formComponent",
                    ref: formComponent,
                    key: formkey.value,
                    "validation-schema": _unref(schema),
                    onSubmit: _cache[2] || (_cache[2] = (e) => onSubmit(e)),
                    onInvalidSubmit: onInvalidSubmit
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(BaseInput, {
                            name: "number",
                            label: item.rclassificationName,
                            placeholder: "22505555",
                            "label-classes": "text-muted h5 font-weight-normal mr-3",
                            "addon-left-icon": "fas fa-phone",
                            alternative: "",
                            inputGroupClasses: "w-75",
                            value: item.number
                          }, {
                            infoBlock: _withCtx(() => [
                              _hoisted_10
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]),
                          _withDirectives(_createVNode(BaseInput, {
                            name: "rclassificationName",
                            label: item.rclassificationName,
                            placeholder: "Sales Channel",
                            "label-classes": "text-muted h5 font-weight-normal mr-3",
                            "addon-left-icon": "fas fa-phone",
                            alternative: "",
                            inputGroupClasses: "w-75",
                            value: item.rclassificationName
                          }, {
                            infoBlock: _withCtx(() => [
                              _hoisted_11
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]), [
                            [_vShow, false]
                          ]),
                          _withDirectives(_createVNode(BaseInput, {
                            name: "rclassification",
                            label: item.rclassification,
                            alternative: "",
                            value: item.rclassification
                          }, null, 8, ["label", "value"]), [
                            [_vShow, false]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createVNode(_component_base_button, {
                              disabled: loading.value,
                              "native-type": "submit"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_14, [
                                  (!loading.value)
                                    ? (_openBlock(), _createBlock(_component_el_icon, {
                                        key: 0,
                                        size: 20,
                                        color: "#FFFFF",
                                        class: "no-inherit"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(List))
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (loading.value)
                                    ? (_openBlock(), _createElementBlock("i", _hoisted_15))
                                    : _createCommentVNode("", true),
                                  _hoisted_16
                                ])
                              ]),
                              _: 1
                            }, 8, ["disabled"]),
                            _createVNode(_component_el_popconfirm, {
                              "confirm-button-text": "Yes",
                              "cancel-button-text": "Not",
                              icon: _unref(WarningFilled),
                              "icon-color": "#F0463A",
                              width: "400",
                              "show-after": 0,
                              "hide-after": 0,
                              title: 'Are you sure to delete ' + item.rclassificationName + ' configuration?' ,
                              onConfirm: ($event: any) => (deleteClassification(item.rclassification)),
                              "popper-options": { gpuAcceleration: false },
                              teleported: false
                            }, {
                              reference: _withCtx(() => [
                                _createVNode(_component_base_button, {
                                  disabled: loading.value,
                                  type: "danger"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_17, [
                                      (!loading.value)
                                        ? (_openBlock(), _createBlock(_component_el_icon, {
                                            key: 0,
                                            size: 20,
                                            color: "#FFFFF",
                                            class: "no-inherit"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(CircleCloseFilled))
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      (loading.value)
                                        ? (_openBlock(), _createElementBlock("i", _hoisted_18))
                                        : _createCommentVNode("", true),
                                      _hoisted_19
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 2
                            }, 1032, ["icon", "title", "onConfirm"])
                          ])
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["validation-schema"]))
                ]))
              }), 128)),
              _createVNode(Modal, {
                show: openModal.value,
                "body-classes": "py-0 pb-4",
                style: {"animation-duration":"0.3s"},
                onClose: _cache[4] || (_cache[4] = ($event: any) => (openModal.value = false))
              }, {
                header: _withCtx(() => [
                  _hoisted_20
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    (_openBlock(), _createBlock(_unref(Form), {
                      class: "w-100",
                      ref_key: "formComponent",
                      ref: formComponent,
                      key: formkey.value,
                      "validation-schema": _unref(schema),
                      onSubmit: _cache[3] || (_cache[3] = (e) => {onSubmit(e); getData();openModal.value=false;}),
                      onInvalidSubmit: onInvalidSubmit
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _createVNode(BaseInput, {
                              name: "rclassification",
                              label: "Request classification",
                              placeholder: "sales,support",
                              "label-classes": "text-muted h5 font-weight-normal mr-3",
                              "addon-left-icon": "fas fa-exchange-alt",
                              alternative: "",
                              inputGroupClasses: "w-100",
                              value: ""
                            }, {
                              infoBlock: _withCtx(() => [
                                _hoisted_23
                              ]),
                              _: 1
                            }),
                            _createVNode(BaseInput, {
                              name: "rclassificationName",
                              label: "Request classification label",
                              placeholder: "Support channel",
                              "label-classes": "text-muted h5 font-weight-normal mr-3",
                              "addon-left-icon": "fas fa-chevron-right",
                              alternative: "",
                              inputGroupClasses: "w-100",
                              value: ""
                            }, {
                              infoBlock: _withCtx(() => [
                                _hoisted_24
                              ]),
                              _: 1
                            }),
                            _createVNode(BaseInput, {
                              name: "number",
                              label: "Request classification number",
                              placeholder: "22505555",
                              "label-classes": "text-muted h5 font-weight-normal mr-3",
                              "addon-left-icon": "fas fa-phone",
                              alternative: "",
                              inputGroupClasses: "w-100",
                              value: ""
                            }, {
                              infoBlock: _withCtx(() => [
                                _hoisted_25
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _createVNode(_component_base_button, {
                                disabled: loading.value,
                                "native-type": "submit"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_28, [
                                    (!loading.value)
                                      ? (_openBlock(), _createBlock(_component_el_icon, {
                                          key: 0,
                                          size: 20,
                                          color: "#FFFFF",
                                          class: "no-inherit"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(List))
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    (loading.value)
                                      ? (_openBlock(), _createElementBlock("i", _hoisted_29))
                                      : _createCommentVNode("", true),
                                    _hoisted_30
                                  ])
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["validation-schema"]))
                  ])
                ]),
                _: 1
              }, 8, ["show"])
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})